import React, { FC, ReactNode, isValidElement, ChangeEvent, useState, useEffect } from 'react';
import classNames from 'classnames/bind';
import styles from './index.pcss';
import properties from '../../../modules/ajio-util/properties';

const LoadingHomeRate = (props: any) => {
  const cx = classNames.bind(styles);
  const { positionPart, topPart, isAjiogram } = props;

  const imageBaseRef = `${properties.getProperty('imageBaseUrl')}/static/img/`;
  return (
    <div
      className={cx('rating-widget')}
      style={{
        backgroundColor: isAjiogram ? '#202020' : 'white',
        paddingTop: '5px',
        paddingBottom: '5px',
        position: positionPart,
        top: topPart
      }}
    >
      <div
        className={cx('rating-top-head')}
        style={{
          backgroundColor: '#e8ebed',
          width: '160px',
          marginLeft: '15px',
          height: '22px'
        }}
      >
        <span className={cx('Rate-your-purchase')} />
      </div>
      {/* img section will be left as per vds and it will dynamicall */}

      {/* Logic for first 3 items */}
      <div className={cx('unrated-product-details')}>
        <div
          className={cx('left-rate-div')}
          style={{
            backgroundColor: '#e8ebed',
            width: '110px',
            height: '140px',
            marginLeft: '15px',
            borderRadius: '21px'
          }}
        />

        {/* main div */}
        <div className={cx('right-rate-div')}>
          {/* title div  */}
          <p
            className={cx('prod-ttl')}
            id="product_title"
            style={{ backgroundColor: '#e8ebed', width: '45px', height: '21px' }}
          />
          {/* subtitle div  */}
          <p
            className={cx('prod-sub-ttl')}
            id="product_desc"
            style={{ backgroundColor: '#e8ebed', width: '160px', height: '20px' }}
          />
          {/* rating  div  */}
          <div className={cx('star-ratings')}>
            <div className={cx('starContainer')} style={{ marginBottom: '20px' }}>
              <button
                className={cx('star-icon-button', 'lg')}
                style={{ border: 'none', background: 'transparent', width: '35px' }}
              >
                <img className={cx('imageIcon')} src={`${imageBaseRef}loading-star.svg`} alt='Star icon'/>
              </button>
              <button
                className={cx('star-icon-button', 'lg')}
                style={{ border: 'none', background: 'transparent', width: '35px' }}
              >
                <img className={cx('imageIcon')} src={`${imageBaseRef}loading-star.svg`} alt='Star icon'/>
              </button>
              <button
                className={cx('star-icon-button', 'lg')}
                style={{ border: 'none', background: 'transparent', width: '35px' }}
              >
                <img className={cx('imageIcon')} src={`${imageBaseRef}loading-star.svg`} alt='Star icon'/>
              </button>
              <button
                className={cx('star-icon-button', 'lg')}
                style={{ border: 'none', background: 'transparent', width: '35px' }}
              >
                <img className={cx('imageIcon')} src={`${imageBaseRef}loading-star.svg`} alt='Star icon'/>
              </button>
              <button
                className={cx('star-icon-button', 'lg')}
                style={{ border: 'none', background: 'transparent', width: '35px' }}
              >
                <img className={cx('imageIcon')} src={`${imageBaseRef}loading-star.svg`} alt='Star icon'/>
              </button>
            </div>
            <p
              className={cx('Tap-on-the-stars-to-rate-your-experience')}
              style={{ backgroundColor: '#e8ebed', width: '160px', height: '20px' }}
            />
          </div>
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', margin: '25px 0 25px 0' }}>
        <p
          className="anuj"
          style={{
            width: '24px',
            height: '4px',
            margin: '0px 0px 0px 4px',
            borderRadius: '2px',
            backgroundColor: '#e8ebed'
          }}
        />
        <p
          className="anuj"
          style={{
            width: '24px',
            height: '4px',
            margin: '0px 0px 0px 4px',
            borderRadius: '2px',
            backgroundColor: '#e8ebed'
          }}
        />
        <p
          className="anuj"
          style={{
            width: '24px',
            height: '4px',
            margin: '0px 0px 0px 4px',
            borderRadius: '2px',
            backgroundColor: '#e8ebed'
          }}
        />
      </div>
    </div>
  );
};

export default LoadingHomeRate;
